import * as z from "zod";
import {SalesManagementResModel} from "./SalesManagementResModel";
import {DEFAULT_SALES_TARGET_RES, SalesTargetResModel} from "./SalesTargetResModel";

export const schema = z.object({
	salesTarget: SalesTargetResModel.model,
	salesManagements: z.array(SalesManagementResModel.model)
});

const model = schema.transform((values) => ({
	...values
}));

export const SalesManagementSearchResModel = {schema, model};
export type ISalesManagementSearchResModel = z.infer<typeof SalesManagementSearchResModel.model>;
export const DEFAULT_SALES_MANAGEMENT_SEARCH_RES: ISalesManagementSearchResModel = {
	salesTarget: DEFAULT_SALES_TARGET_RES,
	salesManagements: []
};
